import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "row" }
const _hoisted_2 = { class: "col-md-3 col-sm-6" }
const _hoisted_3 = { class: "card mb-25 border-0 rounded-0 bg-white stats-box" }
const _hoisted_4 = { class: "card-body pe-20 ps-20 pe-md-25 ps-md-25 pe-lg-15 ps-lg-15" }
const _hoisted_5 = { class: "d-flex align-items-center" }
const _hoisted_6 = { class: "title ms-15" }
const _hoisted_7 = { class: "fw-black mb-8 lh-1" }
const _hoisted_8 = { class: "col-md-3 col-sm-6" }
const _hoisted_9 = { class: "card mb-25 border-0 rounded-0 bg-white stats-box" }
const _hoisted_10 = { class: "card-body pe-20 ps-20 pe-md-25 ps-md-25 pe-lg-15 ps-lg-15" }
const _hoisted_11 = { class: "d-flex align-items-center" }
const _hoisted_12 = { class: "title ms-15" }
const _hoisted_13 = { class: "fw-black mb-8 lh-1" }
const _hoisted_14 = { class: "col-md-3 col-sm-6" }
const _hoisted_15 = { class: "card mb-25 border-0 rounded-0 bg-white stats-box" }
const _hoisted_16 = { class: "card-body pe-20 ps-20 pe-md-25 ps-md-25 pe-lg-15 ps-lg-15" }
const _hoisted_17 = { class: "d-flex align-items-center" }
const _hoisted_18 = { class: "title ms-15" }
const _hoisted_19 = { class: "fw-black mb-8 lh-1" }
const _hoisted_20 = { class: "col-md-3 col-sm-6" }
const _hoisted_21 = { class: "card mb-25 border-0 rounded-0 bg-white stats-box" }
const _hoisted_22 = { class: "card-body pe-20 ps-20 pe-md-25 ps-md-25 pe-lg-15 ps-lg-15" }
const _hoisted_23 = { class: "d-flex align-items-center" }
const _hoisted_24 = { class: "title ms-15" }
const _hoisted_25 = { class: "fw-black mb-8 lh-1" }
const _hoisted_26 = { class: "col-md-3 col-sm-6" }
const _hoisted_27 = { class: "card mb-25 border-0 rounded-0 bg-white stats-box" }
const _hoisted_28 = { class: "card-body pe-20 ps-20 pe-md-25 ps-md-25 pe-lg-15 ps-lg-15" }
const _hoisted_29 = { class: "d-flex align-items-center" }
const _hoisted_30 = { class: "title ms-15" }
const _hoisted_31 = { class: "fw-black mb-8 lh-1" }
const _hoisted_32 = { class: "col-md-3 col-sm-6" }
const _hoisted_33 = { class: "card mb-25 border-0 rounded-0 bg-white stats-box" }
const _hoisted_34 = { class: "card-body pe-20 ps-20 pe-md-25 ps-md-25 pe-lg-15 ps-lg-15" }
const _hoisted_35 = { class: "d-flex align-items-center" }
const _hoisted_36 = { class: "title ms-15" }
const _hoisted_37 = { class: "fw-black mb-8 lh-1" }
const _hoisted_38 = { class: "col-md-3 col-sm-6" }
const _hoisted_39 = { class: "card mb-25 border-0 rounded-0 bg-white stats-box" }
const _hoisted_40 = { class: "card-body pe-20 ps-20 pe-md-25 ps-md-25 pe-lg-15 ps-lg-15" }
const _hoisted_41 = { class: "d-flex align-items-center" }
const _hoisted_42 = { class: "title ms-15" }
const _hoisted_43 = { class: "fw-black mb-8 lh-1" }
const _hoisted_44 = { class: "col-md-3 col-sm-6" }
const _hoisted_45 = { class: "card mb-25 border-0 rounded-0 bg-white stats-box" }
const _hoisted_46 = { class: "card-body pe-20 ps-20 pe-md-25 ps-md-25 pe-lg-15 ps-lg-15" }
const _hoisted_47 = { class: "d-flex align-items-center" }
const _hoisted_48 = { class: "title ms-15" }
const _hoisted_49 = { class: "fw-black mb-8 lh-1" }
const _hoisted_50 = { class: "col-md-3 col-sm-6" }
const _hoisted_51 = { class: "card mb-25 border-0 rounded-0 bg-white stats-box" }
const _hoisted_52 = { class: "card-body pe-20 ps-20 pe-md-25 ps-md-25 pe-lg-15 ps-lg-15" }
const _hoisted_53 = { class: "d-flex align-items-center" }
const _hoisted_54 = { class: "title ms-15" }
const _hoisted_55 = { class: "fw-black mb-8 lh-1" }
const _hoisted_56 = { class: "col-md-3 col-sm-6" }
const _hoisted_57 = { class: "card mb-25 border-0 rounded-0 bg-white stats-box" }
const _hoisted_58 = { class: "card-body pe-20 ps-20 pe-md-25 ps-md-25 pe-lg-15 ps-lg-15" }
const _hoisted_59 = { class: "d-flex align-items-center" }
const _hoisted_60 = { class: "title ms-15" }
const _hoisted_61 = { class: "fw-black mb-8 lh-1" }
const _hoisted_62 = { class: "col-md-3 col-sm-6" }
const _hoisted_63 = { class: "card mb-25 border-0 rounded-0 bg-white stats-box" }
const _hoisted_64 = { class: "card-body pe-20 ps-20 pe-md-25 ps-md-25 pe-lg-15 ps-lg-15" }
const _hoisted_65 = { class: "d-flex align-items-center" }
const _hoisted_66 = { class: "title ms-15" }
const _hoisted_67 = { class: "fw-black mb-8 lh-1" }
const _hoisted_68 = { class: "col-md-3 col-sm-6" }
const _hoisted_69 = { class: "card mb-25 border-0 rounded-0 bg-white stats-box" }
const _hoisted_70 = { class: "card-body pe-20 ps-20 pe-md-25 ps-md-25 pe-lg-15 ps-lg-15" }
const _hoisted_71 = { class: "d-flex align-items-center" }
const _hoisted_72 = { class: "title ms-15" }
const _hoisted_73 = { class: "fw-black mb-8 lh-1" }
const _hoisted_74 = { class: "col-md-3 col-sm-6" }
const _hoisted_75 = { class: "card mb-25 border-0 rounded-0 bg-white stats-box" }
const _hoisted_76 = { class: "card-body pe-20 ps-20 pe-md-25 ps-md-25 pe-lg-15 ps-lg-15" }
const _hoisted_77 = { class: "d-flex align-items-center" }
const _hoisted_78 = { class: "title ms-15" }
const _hoisted_79 = { class: "fw-black mb-8 lh-1" }
const _hoisted_80 = { class: "col-md-3 col-sm-6" }
const _hoisted_81 = { class: "card mb-25 border-0 rounded-0 bg-white stats-box" }
const _hoisted_82 = { class: "card-body pe-20 ps-20 pe-md-25 ps-md-25 pe-lg-15 ps-lg-15" }
const _hoisted_83 = { class: "d-flex align-items-center" }
const _hoisted_84 = { class: "title ms-15" }
const _hoisted_85 = { class: "fw-black mb-8 lh-1" }
const _hoisted_86 = { class: "col-md-3 col-sm-6" }
const _hoisted_87 = { class: "card mb-25 border-0 rounded-0 bg-white stats-box" }
const _hoisted_88 = { class: "card-body pe-20 ps-20 pe-md-25 ps-md-25 pe-lg-15 ps-lg-15" }
const _hoisted_89 = { class: "d-flex align-items-center" }
const _hoisted_90 = { class: "title ms-15" }
const _hoisted_91 = { class: "fw-black mb-8 lh-1" }
const _hoisted_92 = { class: "col-md-3 col-sm-6" }
const _hoisted_93 = { class: "card mb-25 border-0 rounded-0 bg-white stats-box" }
const _hoisted_94 = { class: "card-body pe-20 ps-20 pe-md-25 ps-md-25 pe-lg-15 ps-lg-15" }
const _hoisted_95 = { class: "d-flex align-items-center" }
const _hoisted_96 = { class: "title ms-15" }
const _hoisted_97 = { class: "fw-black mb-8 lh-1" }
const _hoisted_98 = { class: "col-md-3 col-sm-6" }
const _hoisted_99 = { class: "card mb-25 border-0 rounded-0 bg-white stats-box" }
const _hoisted_100 = { class: "card-body pe-20 ps-20 pe-md-25 ps-md-25 pe-lg-15 ps-lg-15" }
const _hoisted_101 = { class: "d-flex align-items-center" }
const _hoisted_102 = { class: "title ms-15" }
const _hoisted_103 = { class: "fw-black mb-8 lh-1" }
const _hoisted_104 = { class: "col-md-3 col-sm-6" }
const _hoisted_105 = { class: "card mb-25 border-0 rounded-0 bg-white stats-box" }
const _hoisted_106 = { class: "card-body pe-20 ps-20 pe-md-25 ps-md-25 pe-lg-15 ps-lg-15" }
const _hoisted_107 = { class: "d-flex align-items-center" }
const _hoisted_108 = { class: "title ms-15" }
const _hoisted_109 = { class: "fw-black mb-8 lh-1" }
const _hoisted_110 = { class: "col-md-3 col-sm-6" }
const _hoisted_111 = { class: "card mb-25 border-0 rounded-0 bg-white stats-box" }
const _hoisted_112 = { class: "card-body pe-20 ps-20 pe-md-25 ps-md-25 pe-lg-15 ps-lg-15" }
const _hoisted_113 = { class: "d-flex align-items-center" }
const _hoisted_114 = { class: "title ms-15" }
const _hoisted_115 = { class: "fw-black mb-8 lh-1" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _cache[1] || (_cache[1] = _createElementVNode("div", { class: "icon position-relative rounded-circle text-center text-primary" }, [
              _createElementVNode("i", { class: "flaticon-sterile-box" })
            ], -1)),
            _createElementVNode("div", _hoisted_6, [
              _cache[0] || (_cache[0] = _createElementVNode("span", { class: "d-block mb-7 fs-13 text-uppercase fw-medium text-dark-emphasis" }, " Total Utilisateurs ", -1)),
              _createElementVNode("h4", _hoisted_7, _toDisplayString(_ctx.data?.Totalusers), 1)
            ])
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_8, [
      _createElementVNode("div", _hoisted_9, [
        _createElementVNode("div", _hoisted_10, [
          _createElementVNode("div", _hoisted_11, [
            _cache[3] || (_cache[3] = _createElementVNode("div", { class: "icon position-relative rounded-circle text-center text-danger" }, [
              _createElementVNode("i", { class: "flaticon-users-group" })
            ], -1)),
            _createElementVNode("div", _hoisted_12, [
              _cache[2] || (_cache[2] = _createElementVNode("span", { class: "d-block mb-7 fs-13 text-uppercase fw-medium text-dark-emphasis" }, " Total Clients ", -1)),
              _createElementVNode("h4", _hoisted_13, _toDisplayString(_ctx.data?.Totalclients), 1)
            ])
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_14, [
      _createElementVNode("div", _hoisted_15, [
        _createElementVNode("div", _hoisted_16, [
          _createElementVNode("div", _hoisted_17, [
            _cache[5] || (_cache[5] = _createElementVNode("div", { class: "icon position-relative rounded-circle text-center text-success" }, [
              _createElementVNode("i", { class: "flaticon-sterile-box" })
            ], -1)),
            _createElementVNode("div", _hoisted_18, [
              _cache[4] || (_cache[4] = _createElementVNode("span", { class: "d-block mb-7 fs-13 text-uppercase fw-medium text-dark-emphasis" }, " Total Colis ", -1)),
              _createElementVNode("h4", _hoisted_19, _toDisplayString(_ctx.data?.Totalcolis), 1)
            ])
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_20, [
      _createElementVNode("div", _hoisted_21, [
        _createElementVNode("div", _hoisted_22, [
          _createElementVNode("div", _hoisted_23, [
            _cache[7] || (_cache[7] = _createElementVNode("div", { class: "icon position-relative rounded-circle text-center text-info" }, [
              _createElementVNode("i", { class: "flaticon-cube-3d" })
            ], -1)),
            _createElementVNode("div", _hoisted_24, [
              _cache[6] || (_cache[6] = _createElementVNode("span", { class: "d-block mb-7 fs-13 text-uppercase fw-medium text-dark-emphasis" }, " Total colis ramassés ", -1)),
              _createElementVNode("h4", _hoisted_25, _toDisplayString(_ctx.data?.TotalRamasse), 1)
            ])
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_26, [
      _createElementVNode("div", _hoisted_27, [
        _createElementVNode("div", _hoisted_28, [
          _createElementVNode("div", _hoisted_29, [
            _cache[9] || (_cache[9] = _createElementVNode("div", { class: "icon position-relative rounded-circle text-center text-warning" }, [
              _createElementVNode("i", { class: "flaticon-parcel" })
            ], -1)),
            _createElementVNode("div", _hoisted_30, [
              _cache[8] || (_cache[8] = _createElementVNode("span", { class: "d-block mb-7 fs-13 text-uppercase fw-medium text-dark-emphasis" }, " Total produits stock ", -1)),
              _createElementVNode("h4", _hoisted_31, _toDisplayString(_ctx.data?.TotalProduits), 1)
            ])
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_32, [
      _createElementVNode("div", _hoisted_33, [
        _createElementVNode("div", _hoisted_34, [
          _createElementVNode("div", _hoisted_35, [
            _cache[11] || (_cache[11] = _createElementVNode("div", { class: "icon position-relative rounded-circle text-center text-warning" }, [
              _createElementVNode("i", { class: "flaticon-draft" })
            ], -1)),
            _createElementVNode("div", _hoisted_36, [
              _cache[10] || (_cache[10] = _createElementVNode("span", { class: "d-block mb-7 fs-13 text-uppercase fw-medium text-dark-emphasis" }, " Total bons de réception ", -1)),
              _createElementVNode("h4", _hoisted_37, _toDisplayString(_ctx.data?.TotalBonRecetion), 1)
            ])
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_38, [
      _createElementVNode("div", _hoisted_39, [
        _createElementVNode("div", _hoisted_40, [
          _createElementVNode("div", _hoisted_41, [
            _cache[13] || (_cache[13] = _createElementVNode("div", { class: "icon position-relative rounded-circle text-center text-primary" }, [
              _createElementVNode("i", { class: "flaticon-document" })
            ], -1)),
            _createElementVNode("div", _hoisted_42, [
              _cache[12] || (_cache[12] = _createElementVNode("span", { class: "d-block mb-7 fs-13 text-uppercase fw-medium text-dark-emphasis" }, " Total bons de livraison ", -1)),
              _createElementVNode("h4", _hoisted_43, _toDisplayString(_ctx.data?.TotalBL), 1)
            ])
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_44, [
      _createElementVNode("div", _hoisted_45, [
        _createElementVNode("div", _hoisted_46, [
          _createElementVNode("div", _hoisted_47, [
            _cache[15] || (_cache[15] = _createElementVNode("div", { class: "icon position-relative rounded-circle text-center text-secondary" }, [
              _createElementVNode("i", { class: "flaticon-document" })
            ], -1)),
            _createElementVNode("div", _hoisted_48, [
              _cache[14] || (_cache[14] = _createElementVNode("span", { class: "d-block mb-7 fs-13 text-uppercase fw-medium text-dark-emphasis" }, " Total bons de livraison en stock ", -1)),
              _createElementVNode("h4", _hoisted_49, _toDisplayString(_ctx.data?.TotalBLStock), 1)
            ])
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_50, [
      _createElementVNode("div", _hoisted_51, [
        _createElementVNode("div", _hoisted_52, [
          _createElementVNode("div", _hoisted_53, [
            _cache[17] || (_cache[17] = _createElementVNode("div", { class: "icon position-relative rounded-circle text-center text-danger" }, [
              _createElementVNode("i", { class: "flaticon-telegram" })
            ], -1)),
            _createElementVNode("div", _hoisted_54, [
              _cache[16] || (_cache[16] = _createElementVNode("span", { class: "d-block mb-7 fs-13 text-uppercase fw-medium text-dark-emphasis" }, " Total bons d'envoi ", -1)),
              _createElementVNode("h4", _hoisted_55, _toDisplayString(_ctx.data?.TotalBENV), 1)
            ])
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_56, [
      _createElementVNode("div", _hoisted_57, [
        _createElementVNode("div", _hoisted_58, [
          _createElementVNode("div", _hoisted_59, [
            _cache[19] || (_cache[19] = _createElementVNode("div", { class: "icon position-relative rounded-circle text-center text-success" }, [
              _createElementVNode("i", { class: "flaticon-notes" })
            ], -1)),
            _createElementVNode("div", _hoisted_60, [
              _cache[18] || (_cache[18] = _createElementVNode("span", { class: "d-block mb-7 fs-13 text-uppercase fw-medium text-dark-emphasis" }, " Total bons de distribution ", -1)),
              _createElementVNode("h4", _hoisted_61, _toDisplayString(_ctx.data?.TotalBDisctr), 1)
            ])
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_62, [
      _createElementVNode("div", _hoisted_63, [
        _createElementVNode("div", _hoisted_64, [
          _createElementVNode("div", _hoisted_65, [
            _cache[21] || (_cache[21] = _createElementVNode("div", { class: "icon position-relative rounded-circle text-center text-warning" }, [
              _createElementVNode("i", { class: "flaticon-fast-delivery" })
            ], -1)),
            _createElementVNode("div", _hoisted_66, [
              _cache[20] || (_cache[20] = _createElementVNode("span", { class: "d-block mb-7 fs-13 text-uppercase fw-medium text-dark-emphasis" }, " Total bons de paiment (Livreur) ", -1)),
              _createElementVNode("h4", _hoisted_67, _toDisplayString(_ctx.data?.TotalBonPaie), 1)
            ])
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_68, [
      _createElementVNode("div", _hoisted_69, [
        _createElementVNode("div", _hoisted_70, [
          _createElementVNode("div", _hoisted_71, [
            _cache[23] || (_cache[23] = _createElementVNode("div", { class: "icon position-relative rounded-circle text-center text-danger" }, [
              _createElementVNode("i", { class: "flaticon-fast-delivery" })
            ], -1)),
            _createElementVNode("div", _hoisted_72, [
              _cache[22] || (_cache[22] = _createElementVNode("span", { class: "d-block mb-7 fs-13 text-uppercase fw-medium text-dark-emphasis" }, " Total bons de paiment (Zone) ", -1)),
              _createElementVNode("h4", _hoisted_73, _toDisplayString(_ctx.data?.TotalBonZPaie), 1)
            ])
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_74, [
      _createElementVNode("div", _hoisted_75, [
        _createElementVNode("div", _hoisted_76, [
          _createElementVNode("div", _hoisted_77, [
            _cache[25] || (_cache[25] = _createElementVNode("div", { class: "icon position-relative rounded-circle text-center text-info" }, [
              _createElementVNode("i", { class: "flaticon-user" })
            ], -1)),
            _createElementVNode("div", _hoisted_78, [
              _cache[24] || (_cache[24] = _createElementVNode("span", { class: "d-block mb-7 fs-13 text-uppercase fw-medium text-dark-emphasis" }, " Total bons de retour (Client) ", -1)),
              _createElementVNode("h4", _hoisted_79, _toDisplayString(_ctx.data?.TotalBonRetourCust), 1)
            ])
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_80, [
      _createElementVNode("div", _hoisted_81, [
        _createElementVNode("div", _hoisted_82, [
          _createElementVNode("div", _hoisted_83, [
            _cache[27] || (_cache[27] = _createElementVNode("div", { class: "icon position-relative rounded-circle text-center text-primary" }, [
              _createElementVNode("i", { class: "flaticon-project" })
            ], -1)),
            _createElementVNode("div", _hoisted_84, [
              _cache[26] || (_cache[26] = _createElementVNode("span", { class: "d-block mb-7 fs-13 text-uppercase fw-medium text-dark-emphasis" }, " Total bons de retour (Agence) ", -1)),
              _createElementVNode("h4", _hoisted_85, _toDisplayString(_ctx.data?.TotalBonRetourAgence), 1)
            ])
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_86, [
      _createElementVNode("div", _hoisted_87, [
        _createElementVNode("div", _hoisted_88, [
          _createElementVNode("div", _hoisted_89, [
            _cache[29] || (_cache[29] = _createElementVNode("div", { class: "icon position-relative rounded-circle text-center text-success" }, [
              _createElementVNode("i", { class: "flaticon-money" })
            ], -1)),
            _createElementVNode("div", _hoisted_90, [
              _cache[28] || (_cache[28] = _createElementVNode("span", { class: "d-block mb-7 fs-13 text-uppercase fw-medium text-dark-emphasis" }, " Total factures ", -1)),
              _createElementVNode("h4", _hoisted_91, _toDisplayString(_ctx.data?.TotalInvoices), 1)
            ])
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_92, [
      _createElementVNode("div", _hoisted_93, [
        _createElementVNode("div", _hoisted_94, [
          _createElementVNode("div", _hoisted_95, [
            _cache[31] || (_cache[31] = _createElementVNode("div", { class: "icon position-relative rounded-circle text-center text-info" }, [
              _createElementVNode("i", { class: "flaticon-money" })
            ], -1)),
            _createElementVNode("div", _hoisted_96, [
              _cache[30] || (_cache[30] = _createElementVNode("span", { class: "d-block mb-7 fs-13 text-uppercase fw-medium text-dark-emphasis" }, " Total virement ", -1)),
              _createElementVNode("h4", _hoisted_97, _toDisplayString(_ctx.data?.TotalTransfer), 1)
            ])
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_98, [
      _createElementVNode("div", _hoisted_99, [
        _createElementVNode("div", _hoisted_100, [
          _createElementVNode("div", _hoisted_101, [
            _cache[33] || (_cache[33] = _createElementVNode("div", { class: "icon position-relative rounded-circle text-center text-danger" }, [
              _createElementVNode("i", { class: "flaticon-information" })
            ], -1)),
            _createElementVNode("div", _hoisted_102, [
              _cache[32] || (_cache[32] = _createElementVNode("span", { class: "d-block mb-7 fs-13 text-uppercase fw-medium text-dark-emphasis" }, " Total Réclamations ", -1)),
              _createElementVNode("h4", _hoisted_103, _toDisplayString(_ctx.data?.TotalClaim), 1)
            ])
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_104, [
      _createElementVNode("div", _hoisted_105, [
        _createElementVNode("div", _hoisted_106, [
          _createElementVNode("div", _hoisted_107, [
            _cache[35] || (_cache[35] = _createElementVNode("div", { class: "icon position-relative rounded-circle text-center text-danger" }, [
              _createElementVNode("i", { class: "flaticon-form" })
            ], -1)),
            _createElementVNode("div", _hoisted_108, [
              _cache[34] || (_cache[34] = _createElementVNode("span", { class: "d-block mb-7 fs-13 text-uppercase fw-medium text-dark-emphasis" }, " Total demandes de retour ", -1)),
              _createElementVNode("h4", _hoisted_109, _toDisplayString(_ctx.data?.TotalRtnRequest), 1)
            ])
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_110, [
      _createElementVNode("div", _hoisted_111, [
        _createElementVNode("div", _hoisted_112, [
          _createElementVNode("div", _hoisted_113, [
            _cache[37] || (_cache[37] = _createElementVNode("div", { class: "icon position-relative rounded-circle text-center text-primary" }, [
              _createElementVNode("i", { class: "flaticon-information" })
            ], -1)),
            _createElementVNode("div", _hoisted_114, [
              _cache[36] || (_cache[36] = _createElementVNode("span", { class: "d-block mb-7 fs-13 text-uppercase fw-medium text-dark-emphasis" }, " Total demandes de ramassage ", -1)),
              _createElementVNode("h4", _hoisted_115, _toDisplayString(_ctx.data?.TotalPickRequest), 1)
            ])
          ])
        ])
      ])
    ])
  ]))
}